import { School, Globe, Star } from 'lucide-react';
import type { CoverageStats } from '../../types';

interface StatsBarProps {
  stats: CoverageStats | null;
  isLoading: boolean;
}

export default function StatsBar({ stats, isLoading }: StatsBarProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-3 gap-4 mb-4">
        {[0, 1, 2].map((i) => (
          <div key={i} className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 animate-pulse">
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2 mb-2" />
            <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/3" />
          </div>
        ))}
      </div>
    );
  }

  const cards = [
    {
      icon: <School className="h-5 w-5 text-blue-500" />,
      label: 'Total Schools',
      value: stats?.totalSchools ?? 0,
      bg: 'bg-blue-50 dark:bg-blue-900/30',
    },
    {
      icon: <Globe className="h-5 w-5 text-indigo-500" />,
      label: 'Regions',
      value: stats?.regionCount ?? 0,
      bg: 'bg-indigo-50 dark:bg-indigo-900/30',
    },
    {
      icon: <Star className="h-5 w-5 text-amber-500" />,
      label: 'Named Accounts',
      value: stats?.namedAccounts ?? 0,
      bg: 'bg-amber-50 dark:bg-amber-900/30',
    },
  ];

  return (
    <div className="grid grid-cols-3 gap-4 mb-4">
      {cards.map((card) => (
        <div key={card.label} className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 flex items-center gap-4">
          <div className={`${card.bg} rounded-lg p-3`}>{card.icon}</div>
          <div>
            <div className="text-2xl font-bold text-gray-900 dark:text-gray-100">{card.value.toLocaleString()}</div>
            <div className="text-sm text-gray-500 dark:text-gray-400">{card.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
